<div class="company-filter-wrapper kendo-formfield">
  <div class="filter-row">
    <div class="operator-dropdown">
      <kendo-label text="Company Name"></kendo-label>
      <kendo-dropdownlist [data]="operators" [value]="operator" textField="text" valueField="value"
        [valuePrimitive]="true" fillMode="outline" (valueChange)="onOperatorChange($event)">
      </kendo-dropdownlist>
    </div>
    <div class="company-multiselect">
      <app-sage-class-select-kendo label="" placeholder="Select Sage class" [selectedId]="selectedCompanyIds"
        (selectionChanged)="onSelectionChanged($event)" (selectedSageClassesChanged)="onSageClassesChanged($event)"
        (enteredPressed)="onEnterPressed()">
      </app-sage-class-select-kendo>
    </div>
  </div>
</div>
